import ProductInfoContainer from 'pricing-pages-lib/js/components/ProductInfoContainer.tsx';
import { CommerceHubFaqs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/CommerceHubFaqs';
import { PPUIPageHeader } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { COMMERCE_PROFESSIONAL } from 'self-service-api/constants/UpgradeProducts';
import BannerSection from '../components/banners/BannerSection';
import PaymentsProcessorsInbound25Wrapper from '../components/commerce-hub/PaymentsProcessorsInbound25Wrapper';
import IntegrationsSection from '../components/common/IntegrationsSection';
import PhoneSupportFooter from '../components/common/PhoneSupportFooter';
import ProductPageSubtitle from '../components/common/ProductPageSubtitle';
import ProductPageTitle from '../components/common/ProductPageTitle';
import ValuePropsSection from '../components/common/ValuePropsSection';
import { CreditsCalloutSection } from '../components/common/credits-callout/CreditsCalloutSection';
import FallbackErrorBanner from '../components/common/loading/FallbackErrorBanner';
import ErrorBoundary from '../components/error-boundary/ErrorBoundary';
import { ERROR_SEVERITY } from '../components/error-boundary/error-severity';
import withErrorBoundary from '../components/error-boundary/withErrorBoundary';
import ProductFeatureTable from '../components/feature-table/ProductFeatureTable';
import HeaderLayout from '../components/layout/HeaderLayout';
import { ProductCardContainer } from '../components/merch-card/card-containers/ProductCardContainer';
import { COMMERCE_HUB_PAGE_CONTENT, COMMERCE_PAGE } from '../constants/ErrorBoundaryNames';
import { DEFAULT } from '../constants/ErrorCauses';
import { NavItemEnum } from '../constants/routing/NavItems';
import { SCREENS } from '../constants/tracking/Screens';
import { MERCH_CARD, TRACKING_SOURCES } from '../constants/tracking/TrackingSources';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { trackPageView } from '../utils/tracking/trackingEventUtils';
import ErrorPage from './ErrorPage';
import MissingInfoFallbackPage from './MissingInfoFallbackPage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CommerceHubPage = () => {
  const navItem = NavItemEnum.COMMERCE;
  const navMarkerName = `${navItem.toUpperCase()}_PAGE`;
  const screen = SCREENS.COMMERCE;
  useDocumentTitle(navItem);
  useEffect(() => {
    trackPageView({
      screen: navItem
    });
  }, [navItem]);
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    fallback: /*#__PURE__*/_jsx(MissingInfoFallbackPage, {
      navItem: navItem
    }),
    errorBoundaryName: COMMERCE_HUB_PAGE_CONTENT,
    severity: ERROR_SEVERITY.HIGH,
    metricsOptions: {
      route: navItem
    },
    children: /*#__PURE__*/_jsxs("div", {
      "data-selenium-id": "page-success",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: navMarkerName
      }), /*#__PURE__*/_jsx(HeaderLayout, {
        selectedNavItem: navItem,
        children: /*#__PURE__*/_jsxs(ProductInfoContainer, {
          children: [/*#__PURE__*/_jsx(BannerSection, {
            screen: screen
          }), /*#__PURE__*/_jsx(FallbackErrorBanner, {}), /*#__PURE__*/_jsxs(PPUIPageHeader, {
            children: [/*#__PURE__*/_jsx(ProductPageTitle, {
              productLine: COMMERCE
            }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
              productLine: COMMERCE
            })]
          }), /*#__PURE__*/_jsx(ProductCardContainer, {
            screen: screen,
            productsToShow: ['commerce-hub-professional', 'commerce-hub-enterprise'],
            trackingSource: MERCH_CARD
          }), /*#__PURE__*/_jsx(PageSection, {
            children: /*#__PURE__*/_jsx(CreditsCalloutSection, {
              navItem: 'commerce'
            })
          }), /*#__PURE__*/_jsx(PageSection, {
            children: /*#__PURE__*/_jsx(ProductFeatureTable, {
              productLine: 'COMMERCE',
              highlightedProducts: ['commerce-hub-professional', 'commerce-hub-enterprise'],
              screen: screen
            }, `commerce`)
          }), /*#__PURE__*/_jsx(PaymentsProcessorsInbound25Wrapper, {}), /*#__PURE__*/_jsx(IntegrationsSection, {}), /*#__PURE__*/_jsx(PageSection, {
            children: /*#__PURE__*/_jsx(CommerceHubFaqs, {})
          }), /*#__PURE__*/_jsx(ValuePropsSection, {}), /*#__PURE__*/_jsx(PhoneSupportFooter, {
            phoneSourceId: TRACKING_SOURCES.COMMERCE_FOOTER,
            screen: SCREENS.COMMERCE,
            upgradeProduct: COMMERCE_PROFESSIONAL
          })]
        })
      })]
    })
  });
};
export default withErrorBoundary(CommerceHubPage, {
  FallbackComponent: () => /*#__PURE__*/_jsx(ErrorPage, {
    errorCause: DEFAULT
  }),
  errorBoundaryName: COMMERCE_PAGE,
  severity: ERROR_SEVERITY.HIGH
});